import { combineReducers } from 'redux';
import { isDevelopment } from 'src/config/development';
import { createWrapper } from 'next-redux-wrapper';
import Bottle from 'bottlejs';
import viewportModule from '@aveneo/frontmoon-viewport-watcher/lib/modules/Viewport';
import { MODULE_NAME as VIEWPORT_MODULE_NAME } from '@aveneo/frontmoon-viewport-watcher/lib/modules/Viewport/constants';

import createStore from 'src/store/createStore';
import { isJSON } from 'src/utils/utils';
import restaurant from './Restaurant';
import notificaiton from './Notification';
import menu from './Menu';
import order from './Order';
import modal from './Modal';
import user from './User';
import catalog from './Catalog';

const modules = [
    restaurant,
    notificaiton,
    menu,
    order,
    modal,
    user,
    catalog,
    {
        reducer: viewportModule[VIEWPORT_MODULE_NAME].reducer,
        moduleName: VIEWPORT_MODULE_NAME
    }
];

const assignModules = (...additionalParams) => () => createStore(
    combineReducers(modules.reduce((result, { moduleName, reducer }) => ({ ...result, [moduleName]: reducer }), {})),
    ...additionalParams
);

export const di = new Bottle();

const wrapper = createWrapper(assignModules(di), {
    debug: isDevelopment,
    serializeState: (state) => JSON.stringify(state),
    deserializeState: (state) => isJSON(state) ? JSON.parse(state) : state
});

export default wrapper;
